"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledInputSearchCards = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isNull2 = _interopRequireDefault(require("lodash/isNull"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _ListSearchCard = _interopRequireDefault(require("../ListSearchCard"));
var _constants = require("../../../../constants");
var _OnClickOutside = _interopRequireDefault(require("../../../OnClickOutside"));
var _Button = _interopRequireDefault(require("../../../Button"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PAGE_SIZE_DEFAULT = 20;
var THRESHOLD_DEFAULT = 5;
var QUANTITY_FOR_REQUST_DEFAULT = 1;
var SearchCardsDropdown = /*#__PURE__*/function (_React$PureComponent) {
  function SearchCardsDropdown(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SearchCardsDropdown);
    _this = _callSuper(this, SearchCardsDropdown, [props]);
    _this.state = {
      type: null,
      value: '',
      isOpen: false
    };
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleCardClick = _this.handleCardClick.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(SearchCardsDropdown, _React$PureComponent);
  return (0, _createClass2["default"])(SearchCardsDropdown, [{
    key: "handleCardClick",
    value: function handleCardClick(data) {
      var onCardClick = this.props.onCardClick;
      this.setState(function () {
        return {
          isOpen: false
        };
      });
      this.setState(function () {
        return {
          value: '',
          type: null
        };
      });
      onCardClick(data);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var onSearch = this.props.onSearch;
      var value = this.state.value;
      onSearch({
        value: value
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.stopPropagation();
      var value = this.state.value;
      var quantity = this.props.quantity;
      if (value.length >= quantity) {
        this.setState(function () {
          return {
            isOpen: true
          };
        });
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      this.setState(function () {
        return {
          isOpen: false
        };
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(_ref) {
      var key = _ref.key;
      if (key === 'Escape') {
        this.setState(function () {
          return {
            isOpen: false
          };
        });
      } else if (key === 'Enter') {
        this.handleSubmit();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(_ref2) {
      var target = _ref2.target;
      var onChange = this.props.onChange;
      var value = target.value;
      this.setState(function () {
        return {
          value: value
        };
      });
      this.setState(function () {
        return {
          isOpen: value !== ''
        };
      });
      onChange(value);
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(newType) {
      var onToggle = this.props.onToggle;
      var type = this.state.type;
      var result = (0, _isNull2["default"])(type) ? newType : null;
      this.setState({
        type: result
      }, function () {
        return onToggle(result);
      });
    }
  }, {
    key: "headRenderer",
    get: function get() {
      var value = this.state.value;
      var placeholder = this.props.placeholder;
      return /*#__PURE__*/_react["default"].createElement(StyledInputSearchCards, {
        placeholder: placeholder,
        value: value,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick
      });
    }
  }, {
    key: "contentRenderer",
    get: function get() {
      var _this2 = this;
      var type = this.state.type;
      var _this$props = this.props,
        clients = _this$props.clients,
        orders = _this$props.orders,
        communications = _this$props.communications,
        messages = _this$props.messages,
        onLoadOrdersRequest = _this$props.onLoadOrdersRequest,
        onLoadClientsRequest = _this$props.onLoadClientsRequest,
        onLoadCommunicationsRequest = _this$props.onLoadCommunicationsRequest,
        onLoadMessagesRequest = _this$props.onLoadMessagesRequest,
        minimumBatchSize = _this$props.minimumBatchSize,
        threshold = _this$props.threshold,
        displayCount = _this$props.displayCount,
        hasNextPage = _this$props.hasNextPage,
        onCallClick = _this$props.onCallClick,
        onEmailClick = _this$props.onEmailClick,
        onCreateTicket = _this$props.onCreateTicket,
        isLoadingClients = _this$props.isLoadingClients,
        isLoadingOrders = _this$props.isLoadingOrders,
        isLoadingCommunications = _this$props.isLoadingCommunications,
        isLoadingMessages = _this$props.isLoadingMessages;
      var isOpen = !!type;
      var action = {
        onToggle: this.handleToggle,
        onCardClick: this.handleCardClick
      };
      return /*#__PURE__*/_react["default"].createElement(StyledSearchCards, this.props, Object.values(_constants.SEARCH_CARD_TYPES).map(function (componentType) {
        var data;
        switch (componentType) {
          case _constants.SEARCH_CARD_TYPES.CLIENTS:
            data = _objectSpread(_objectSpread({}, clients), {}, {
              isLoading: isLoadingClients
            });
            action = _objectSpread(_objectSpread({}, action), {}, {
              onLoadRequest: onLoadClientsRequest,
              onCallClick: onCallClick,
              onEmailClick: onEmailClick,
              onCreateTicket: onCreateTicket
            });
            break;
          case _constants.SEARCH_CARD_TYPES.ORDERS:
            data = _objectSpread(_objectSpread({}, orders), {}, {
              isLoading: isLoadingOrders
            });
            action = _objectSpread(_objectSpread({}, action), {}, {
              onLoadRequest: onLoadOrdersRequest,
              onCreateTicket: onCreateTicket
            });
            break;
          case _constants.SEARCH_CARD_TYPES.COMMUNICATION:
            data = _objectSpread(_objectSpread({}, communications), {}, {
              isLoading: isLoadingCommunications
            });
            action = _objectSpread(_objectSpread({}, action), {}, {
              onLoadRequest: onLoadCommunicationsRequest
            });
            break;
          case _constants.SEARCH_CARD_TYPES.MESSAGES:
            data = _objectSpread(_objectSpread({}, messages), {}, {
              isLoading: isLoadingMessages
            });
            action = _objectSpread(_objectSpread({}, action), {}, {
              onLoadRequest: onLoadMessagesRequest
            });
            break;
          default:
            data = null;
            break;
        }
        return data && _this2.isDisplay(componentType) && /*#__PURE__*/_react["default"].createElement(_ListSearchCard["default"], {
          key: componentType,
          type: componentType,
          total: data.total,
          items: data.items,
          isLoading: data.isLoading,
          action: action,
          minimumBatchSize: minimumBatchSize,
          threshold: threshold,
          open: isOpen,
          hasNextPage: hasNextPage,
          displayCount: displayCount
        });
      }));
    }
  }, {
    key: "isDisplay",
    value: function isDisplay(componentType) {
      var type = this.state.type;
      // Если не выбран тип => отображаем все компоненты
      if ((0, _isNull2["default"])(type)) {
        return true;
      }
      // Иначе отображаем только тот компонент, который выбран
      return componentType === type;
    }
  }, {
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement(_OnClickOutside["default"], {
        onClickOutside: this.handleClickOutside,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus
      }, /*#__PURE__*/_react["default"].createElement(StyledHeader, {
        functional: true,
        onClick: this.handleClick
      }, this.headRenderer), isOpen && /*#__PURE__*/_react["default"].createElement(StyledContentContainer, {
        ref: this.dropdownRef
      }, this.contentRenderer));
    }
  }]);
}(_react["default"].PureComponent);
SearchCardsDropdown.propTypes = {
  className: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  minimumBatchSize: _propTypes["default"].number,
  threshold: _propTypes["default"].number,
  quantity: _propTypes["default"].number,
  displayCount: _propTypes["default"].number,
  hasNextPage: _propTypes["default"].bool,
  clients: _propTypes["default"].shape({
    total: _propTypes["default"].object,
    items: _propTypes["default"].arrayOf(_propTypes["default"].object)
  }),
  orders: _propTypes["default"].shape({
    total: _propTypes["default"].object,
    items: _propTypes["default"].arrayOf(_propTypes["default"].object)
  }),
  communications: _propTypes["default"].shape({
    total: _propTypes["default"].object,
    items: _propTypes["default"].arrayOf(_propTypes["default"].object)
  }),
  messages: _propTypes["default"].shape({
    total: _propTypes["default"].object,
    items: _propTypes["default"].arrayOf(_propTypes["default"].object)
  }),
  onToggle: _propTypes["default"].func,
  onLoadClientsRequest: _propTypes["default"].func,
  onLoadOrdersRequest: _propTypes["default"].func,
  onLoadCommunicationsRequest: _propTypes["default"].func,
  onLoadMessagesRequest: _propTypes["default"].func,
  onSearch: _propTypes["default"].func,
  onCallClick: _propTypes["default"].func,
  onEmailClick: _propTypes["default"].func,
  onCreateTicket: _propTypes["default"].func,
  onCardClick: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  isLoadingClients: _propTypes["default"].bool,
  isLoadingOrders: _propTypes["default"].bool,
  isLoadingCommunications: _propTypes["default"].bool,
  isLoadingMessages: _propTypes["default"].bool
};
SearchCardsDropdown.defaultProps = {
  className: '',
  placeholder: '',
  minimumBatchSize: PAGE_SIZE_DEFAULT,
  threshold: THRESHOLD_DEFAULT,
  quantity: QUANTITY_FOR_REQUST_DEFAULT,
  displayCount: 3,
  hasNextPage: true,
  clients: {
    items: [],
    total: 0
  },
  communications: {
    items: [],
    total: 0
  },
  orders: {
    items: [],
    total: 0
  },
  messages: {
    items: [],
    total: 0
  },
  onLoadCommunicationsRequest: Function.prototype,
  onLoadOrdersRequest: Function.prototype,
  onLoadClientsRequest: Function.prototype,
  onLoadMessagesRequest: Function.prototype,
  onToggle: Function.prototype,
  onSearch: Function.prototype,
  onCallClick: Function.prototype,
  onEmailClick: Function.prototype,
  onCreateTicket: Function.prototype,
  onCardClick: Function.prototype,
  onChange: Function.prototype,
  isLoadingOrders: false,
  isLoadingClients: false,
  isLoadingCommunications: false,
  isLoadingMessages: false
};
var StyledInputSearchCards = exports.StyledInputSearchCards = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "SearchCardsDropdown__StyledInputSearchCards",
  componentId: "sc-1debabo-0"
})(["position:relative;z-index:10;width:100%;height:40px;font-size:13px;border-radius:4px;border:solid 1px #c2c5cc;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}"]);
var StyledHeader = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SearchCardsDropdown__StyledHeader",
  componentId: "sc-1debabo-1"
})(["width:100%;"]);
var StyledSearchCards = _styledComponents["default"].div.withConfig({
  displayName: "SearchCardsDropdown__StyledSearchCards",
  componentId: "sc-1debabo-2"
})(["width:100%;height:auto;background-color:#fff;border:1px;border-radius:6px;display:flex;flex-direction:column;"]);
var StyledContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "SearchCardsDropdown__StyledContentContainer",
  componentId: "sc-1debabo-3"
})(["position:relative;"]);
SearchCardsDropdown.SEARCH_CARD_TYPES = _constants.SEARCH_CARD_TYPES;
var _default = exports["default"] = SearchCardsDropdown;